export default "__VITE_ASSET__D6u1SYqP__"